export enum PayoutStatusId {
  Paid = 1,
  Pending = 2,
  Initializing = 3,
  Removed = 4,
}
